
var engravingProductId = 8271788507404;
var rootUrl = (window.Shopify.routes.root + '/').replace('//', '/');
var loading = false;

// uppercase all words delimited by whitespace or specified char
function ucfirstAll(str, delimiter) {
  var char = delimiter && delimiter.length ? delimiter : " "
  if (!str.length || str.indexOf(delimiter) < 0) return str
  let strings = str.split(delimiter)
  let newString = ""
  let i = 0;
  for (let string of strings) {
    if (i > 0) newString += delimiter;
    newString += string.charAt(0).toUpperCase() + string.slice(1)
    i++;
  }

  return newString
}

function updateEngravingProperty(name, value) {
  
  var addToCartForm =
    document.querySelector('form[action="' + rootUrl + 'cart/add"]') ||
    document.querySelector('form[action="/cart/add"]')

  var propertyName = `properties[${name}]`
  var input = addToCartForm.querySelector(`input[name="${propertyName}"]`)

  if (input) {
    // If the hidden input already exists, update its value
    if (!value || !value.length) {
      input.remove()
    } else {
      input.value = value
    }
  } else if (value && value.length) {
    // If the hidden input doesn't exist, create a new one and append it to the form
    var newInput = document.createElement('input')
    newInput.type = 'hidden'
    newInput.name = propertyName
    newInput.value = value
    addToCartForm.appendChild(newInput)
  }
}

function initEngraving() {
  window.mameido = window.mameido || {}
  variant = window.mameido.variant 
  if (!window.mameido.variant) return;
  engravingProduct = window.mameido.engravingProduct
  window.mameido.variant.properties = {}
  window.mameido.engravingProduct.properties = {}
  if (!window.mameido.variant || !window.mameido.variant.id) return

  var submitButton = document.getElementById('engrave_submit')
  var engraveCancel = document.getElementById('engrave_cancel')
  var engravingTextDisplay = document.getElementById('engraving-text-display')

  var engravingResult = document.getElementById('engraving_result')
  var engravingResultText = document.querySelector(
    '#engraving_result #engraving_result_text'
  )
  var engravingResultDelete = document.querySelector(
    '#engraving_result #delete'
  )

  // Apply initial font value
  var initialFont = engravingFonts[engravingFont.value]
  engravingTextDisplay.style.fontFamily = initialFont
  if (engravingResultText) engravingResultText.style.fontFamily = initialFont
  engravingText.value = engravingResultText.textContent
  updateEngravingProperty('_font', engravingFont.value)
  window.mameido.variant.properties['_g_font'] = engravingFont.value
  updateEngravingProperty('text', engravingText.value)
  toggleSubmitButton(engravingText.value)
  // Remove and re-attach handler to prevent duplicates when variant changes
  cartSubmitButton.removeEventListener('click', addEngravingToCart)
  cartSubmitButton.addEventListener('click', addEngravingToCart)

  document.querySelectorAll('.engraving-background').forEach((bg) => {
    bg.style.display = 'none'
  })

  var currentVariantBg = document.querySelector(
    '#eng_bg_wrapper_' + window.mameido.variant.id
  )
  var engravingOptions = document.querySelector('#engraving_options')

  if (currentVariantBg === null) {
    engravingOptions.style.display = 'none'
    updateEngravingProperty('_gr_parent', '')
    updateEngravingProperty('text', '')
    updateEngravingProperty('_font', '')
    window.mameido.variant.properties = {}
    //cartSubmitButton.removeEventListener('click', addEngravingToCart)
    return
  }

  updateEngravingProperty('_gr_parent', window.mameido.variant.id)
  updateEngravingProperty('text', engravingText.value)
  updateEngravingProperty('_font', engravingFont.value)
  window.mameido.variant.properties['_g_text'] = engravingText.value
  window.mameido.variant.properties['_g_font'] = engravingFont.value

  engravingOptions.style.display = 'block'
  currentVariantBg.style.display = 'block'
  toggleSubmitButton()

  var engravingModal = new theme.Modals('modal-engraving', 'engraving', {
    focusIdOnOpen: 'engraving-text',
    solid: true,
  })

  engraveButton.addEventListener('click', function (event) {
    event.preventDefault()
    engravingModal.open()
    engravingText.value = engravingResultText.textContent
  })

  submitButton.addEventListener('click', function (event) {
    event.preventDefault()
    engravingModal.close()
  })

  engravingText.addEventListener('input', function (event) {
    var text = event.target.value
    if (text && text.length) {
      //text = text.replace(/[^\p{L}\p{N}\p{M}\p{P}\p{Z}^$\n]/gu, '')
      // replace arabic
      text = text.replace(/[\u0600-\u06FF]*/gui, '')
      // replace cyrillic
      text = text.replace(/[\u0400–\u04FF]*/gui, '')
      // replace emojis
      text = text.replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g,'');
      // replace other special characters
      text = text.replace(/[^\p{N}\p{M}\p{P}\p{Z}^A-z^À-ž^u00C0-u00E0]^$/gui, '')
      if (text.indexOf(" ") > 0) text = ucfirstAll(text.toLowerCase(), " ")
      if (text.indexOf("-") > 0) text = ucfirstAll(text.toLowerCase(), "-")
      text = text.charAt(0).toUpperCase() + text.slice(1)
      document.querySelector('#charcount #count').textContent = text.length;
      engravingTextDisplay.textContent = text
      console.log("text", text)
      engravingText.value = text
      engravingResult.style.display = 'flex'
      engravingResultText.textContent = text && text.length ? text : ''
      engraveButton.textContent =
        text && text.length ? 'Gravur bearbeiten' : originalButtonText
      //cartSubmitButton.addEventListener('click', addEngravingToCart)
    } else {
      engravingResult.style.display = 'none'
      engravingResult.textContent = ''
      engravingTextDisplay.textContent = ''
      //cartSubmitButton.removeEventListener('click', addEngravingToCart)
      document.querySelector('#charcount #count').textContent = 0 
    }
    toggleSubmitButton(text)
    updateEngravingProperty('text', text)
  })


  //engravingText.addEventListener('paste', e => {alert('Das Einfügen von Texten ist hier leider nicht möglich'); e.preventDefault()});


  function removeEngraving() {
    engravingTextDisplay.textContent = ''; // Clear the engraving text display
    engraveButton.textContent = originalButtonText;
    engravingText.value = '';
    engravingResultText.textContent = '';
    engravingResult.style.display = 'none';
    updateEngravingProperty('text', ''); // Update the property value to empty
    updateEngravingProperty('_font', '');
    updateEngravingProperty('_gr_parent', '');
    if (window.mameido.variant && window.mameido.variant.properties)
      window.mameido.variant.properties = {};
    toggleSubmitButton();
    //cartSubmitButton.removeEventListener('click', addEngravingToCart);
  
    // If there is an engraving input in the modal, update the engraving text above the button
    var modalEngravingText = document.getElementById('engraving-result-text');
    if (modalEngravingText) {
      modalEngravingText.textContent = '';
    }
  }


  engraveCancel.addEventListener('click', function (event) {
    removeEngraving()
    engravingModal.close()
  })

  engravingResultDelete.addEventListener('click', function (event) {
    removeEngraving()
  })

  engravingFont.addEventListener('change', function (event) {
    var fontStyle = event.target.value
    engravingTextDisplay.style.fontFamily = engravingFonts[fontStyle]
    engravingResultText.style.fontFamily = engravingFonts[fontStyle]
    updateEngravingProperty('_font', fontStyle)
  })
}



function _reverseCartUpdates(updates) {
  var newUpdates = {}
  Object.keys(updates)
    .reverse()
    .forEach((key) => {
      newUpdates[key] = updates[key]
    })
  return newUpdates
}


function collectSelectedGifts(variantId) {
  // Check if there are gift options selected
  var giftOptions = document.querySelectorAll('.gift-option-image')
  var selectedGifts = []
  giftOptions.forEach(function (giftOption) {
    if (giftOption.classList.contains('selected')) {
      var giftProductId = giftOption.getAttribute('data-gift-option-id')
      selectedGifts.push({
        id: giftProductId,
        properties: { _parent: variantId },
      })
    }
  })
  return selectedGifts
}

function addEngravingToCart(event) {
  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  if (loading) {
    return;
  }

  // Loading indicator on add to cart button
  cartSubmitButton.classList.add('btn--loading');

  loading = true;
  
  var variant = window.mameido.variant
  var engravingProduct = window.mameido.engravingProduct;
  var engravingTextValue = engravingText.value;
  var engravingFontValue = engravingFont.value;
  var hasEngravingSet = engravingTextValue && engravingTextValue.length;
  var selectedGifts = collectSelectedGifts(variant.id)
  console.log('selectedGifts 1', selectedGifts)

  // Check if there is an engraving available
  if (hasEngravingSet) {
    // If engraving is available, add the engraving information to the cart item properties
   
    variant.properties = variant.properties || {};
    engravingProduct.properties = engravingProduct.properties || {};

    // Add the engraving information to the cart item properties
    engravingProduct.properties['text'] =
      engravingTextValue && engravingTextValue.length ? engravingTextValue : null;
    engravingProduct.properties['_font'] =
      engravingFontValue && engravingFontValue.length ? engravingFontValue : null;
    engravingProduct.properties['_gr_parent'] = variant.id;
    variant.properties['_g_text'] = engravingTextValue && engravingTextValue.length ? engravingTextValue : null;
     variant.properties['_g_font'] = engravingFontValue && engravingFontValue.length ? engravingFontValue : null;

    var itemsToAddToCart = [variant, ...selectedGifts];
    console.log('selectedGifts', selectedGifts)

     fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items: [engravingProduct] }),
      credentials: 'same-origin',
    }).then(function () {
      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items: itemsToAddToCart }),
        credentials: 'same-origin',
      }).then(function () {
        var cart = new theme.CartDrawer();
        cart.init();
        cart.open();
        cartSubmitButton.classList.remove('btn--loading');
        loading = false;
      });
    });
  } else {

    // If there are selected gift options, add them to the cart
    if (selectedGifts.length) {
      var itemsToAdd = [variant, ...selectedGifts];
      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items: itemsToAdd }),
        credentials: 'same-origin',
      }).then(function () {
        var cart = new theme.CartDrawer();
        cart.init();
        cart.open();
        cartSubmitButton.classList.remove('btn--loading');
        loading = false;
      });
    } else {
      // If no engraving and no gifts are available, simply add the variant to the cart
      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items: [window.mameido.variant] }),
        credentials: 'same-origin',
      }).then(function () {
        var cart = new theme.CartDrawer();
        cart.init();
        cart.open();
        cartSubmitButton.classList.remove('btn--loading');
        loading = false;
      });
    }
  }

  return false;
}

function toggleSubmitButton(text) {
  var submitButton = document.getElementById('engrave_submit')
  var engraveCancel = document.getElementById('engrave_cancel')

  if (!text || !text.length) {
    submitButton.disabled = 'disabled'
    submitButton.style.cursor = 'not-allowed'
    engraveCancel.innerText = 'Abbrechen'
  } else {
    submitButton.disabled = null
    submitButton.style.cursor = null
    engraveCancel.innerText = 'Zurücksetzen'
  }
}

function checkCartConsistency() {
  try {
    fetch(rootUrl + 'cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (json) {
        var engravings = json.items.filter(
          (currentItem) => currentItem.product_id == engravingProductId
        )
        var updates = {}
        if (!engravings || !engravings.length) return json

        engravings.forEach(function (engraving) {
          var parentId = engraving.properties._gr_parent
          var parentFound = json.items.find(
            (currentItem) => currentItem.id === parentId
          )

          if (
            !parentFound || !parentFound.properties['_g_text'] || parentFound.properties['_g_text'] !== engraving.properties['text'] ||
            (parentFound &&
              Math.abs(
                json.items.indexOf(engraving) - json.items.indexOf(parentFound)
              ) > 1)
          ) {
            var index = json.items.indexOf(engraving) + 1
            updates[engraving.key] = 0
          }
        })

        if (Object.keys(updates).length) {
          if (json.items.length === 1) {
            return fetch(window.Shopify.routes.root + 'cart/clear.js').then(
              (response) => response.json()
            )
          }
          return fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            credentials: 'same-origin',
            body: JSON.stringify({ updates }),
          }).then((response) => {
            console.log("updates", Object.keys(updates))
            if (Object.keys(updates).length) {
                var cart = new theme.CartDrawer()
                cart.init()
                cart.open()
            }
            return response.json()
          })
        }

        return json
      })
      .catch(function (error) {
        console.error('Error occurred while checking cart consistency:', error);
        throw error;
      });
  } catch (error) {
    console.error('Error occurred while checking cart consistency:', error);
    throw error;
  }
}


function synchronizeCount(event) {
  event.preventDefault()
  event.stopPropagation()
  var key = event.detail[0]
  var qty = event.detail[1]
  var updates = {}
  console.log('[mameido.js] - synchronize cart count')
  return fetch(window.Shopify.routes.root + 'cart.js').then((response) => {
    return response.json().then((cart) => {
      var _cartItems = cart.items

      var changedProduct = _cartItems.find((prod) => prod.key === key)
      var nextItem = _cartItems[_cartItems.indexOf(changedProduct) + 1]

      if (nextItem && nextItem.product_id === engravingProductId) {
        updates[nextItem.key] = qty
        updates = _reverseCartUpdates(updates)
      } else {
        updates[key] = qty
      }

      try {
        return fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'same-origin',
          body: JSON.stringify({ updates }),
        }).then((response) => {
          if (typeof updates[key] == 'undefined') {
            console.log('updates', updates)
            updates = {}
            updates[key] = qty

            return fetch(window.Shopify.routes.root + 'cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              credentials: 'same-origin',
              body: JSON.stringify({ updates }),
            }).then((response) => {
              var cart = new theme.CartDrawer()
              cart.init()
              cart.open()
              return response.json()
            })
          } else {
            var cart = new theme.CartDrawer()
            cart.init()
            cart.open()
            return response.json()
          }
        })
      } catch (e) {
        console.warn(e)
      }
    })
  })
}



function getImageLightness(imageSrc, callback) {
  var img = document.createElement("img");
  img.src = imageSrc;
  img.style.display = "none";
  document.body.appendChild(img);

  var colorSum = 0;

  img.onload = function() {
      // create canvas
      var canvas = document.createElement("canvas");
      canvas.width = this.width;
      canvas.height = this.height;

      var ctx = canvas.getContext("2d");
      ctx.drawImage(this,0,0);

      var imageData = ctx.getImageData(0,0,canvas.width,canvas.height);
      var data = imageData.data;
      var r,g,b,avg;

      for(var x = 0, len = data.length; x < len; x+=4) {
          r = data[x];
          g = data[x+1];
          b = data[x+2];

          avg = Math.floor((r+g+b)/3);
          colorSum += avg;
      }

      var brightness = Math.floor(colorSum / (this.width*this.height));
      callback(brightness);
  }
}

function setEngravingFontColor() {
  if (!window.mameido.variant || !window.mameido.variant.id) return;
  var image = document.querySelector(
    '#eng_bg_wrapper_' + window.mameido.variant.id +' img'
  )

  if (image) {
    getImageLightness(image.src, function(brightness) {
      var newColor = brightness / 1.41
      var newShadow = newColor - 20
      var display = document.querySelector('#engraving-text-display')
      display.style.backgroundColor = 'rgb(' + newColor + ',' + newColor + ',' + newColor + ')';
      display.style.textShadow = '1px -1px 0px rgba(' + newShadow + ',' + newShadow + ',' + newShadow + ',0.75)';
    })
  }
}

function setVariant() {
  document.addEventListener('variant:change', function (event) {
    window.mameido.variant = event.detail.variant;
    console.log('changing variant');
    initEngraving();
    setEngravingFontColor()
  });
}

function removeAjax(event) {
  if (!event.target.parentNode.classList.contains('cart__remove')) return true;
  event.preventDefault();
  event.stopPropagation();
  var href = event.target.getAttribute('href');
  var query = href.split('?')[1];
  var params = new URLSearchParams(query);
  return theme.cart.changeItem(params.get('id'), params.get('quantity')).then(resp => {
    var cart = new theme.CartDrawer();
    cart.init();
    cart.open();  
  })
}



var cartSubmitButton
var engravingText 
var engravingFont 
var engraveButton 
var originalButtonText

var engravingFonts = {
  'Signature': 'HathemBosteem',
  'Classic': 'Cormorant',
  'Modern': 'Nunito'
}

document.addEventListener('DOMContentLoaded', function () {
  // Initialize cached elements
  // Cached elements
  cartSubmitButton = document.querySelector('button.add-to-cart');
  engravingText = document.getElementById('engraving-text');
  engravingFont = document.getElementById('engraving-font');
  engraveButton = document.querySelector('[data-modal-trigger="modal-engraving"]')
  originalButtonText = engraveButton ? engraveButton.textContent : 'G'
  
  setVariant();
  checkCartConsistency();
  document.addEventListener('cart:quantity.cart-cart-drawer', synchronizeCount, true);
  document.addEventListener('cart:quantity.cart-page', synchronizeCount, true);
  document.addEventListener('cart:quantity.cart-header', synchronizeCount, true);
  // Attach the addEngravingToCart function to the cartSubmitButton click event
  initEngraving();
  setEngravingFontColor();
  document.addEventListener('click', (event) => removeAjax(event))
});

